import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Cb001HomepagePage } from '../../pages/cb001-homepage/cb001-homepage';


/*
  Generated class for the GeneralServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GeneralServiceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello GeneralServiceProvider Provider');
  }

  onGoHome(navCtrl:NavController) {
    console.log("take me home");
    //navCtrl.popToRoot({animate:true});

    navCtrl.setRoot(Cb001HomepagePage);
    navCtrl.popToRoot({animate:true});
    navCtrl.goToRoot({animate:true});
    //navCtrl.push("Cb001HomepagePage");
    


  }
  
}



// WEBPACK FOOTER //
// ./src/providers/general-service/general-service.ts